import blobService from '@/services/blobService'
import fileUploadService from '@/services/fileUploadService'

export default {
  data () {
    return {
      blobMixin: {
        status: {
          unchanged: 0,
          new: 1,
          updated: 2,
          deleted: 3
        }
      }
    }
  },
  mounted () {
    blobService.Init(this)
  },
  computed: {
  },
  methods: {
    async BlobMixin_Download (blob) {
      if (blob && !blob.isNew && !blob.isEdited) {
        const resp = await blobService.Download(blob.idBlob)

        if (resp && (resp.data || resp.data !== '')) {
          this.BlobMixin_DownloadAction(resp.data, blob.bestandsnaam)
        }
      }
    },
    async BlobMixin_SaveBlobs (blobs) {
      if (blobs) {
        const resp = await blobService.Save(blobs)

        if (resp && (resp.data || resp.data !== '')) {
          return resp.data
        }
      }
      return null
    },
    async BlobMixin_DeleteBlobById (idBlob) {
      var blobs = [{
        idBlob: idBlob,
        blobStatus: this.blobMixin.status.deleted
      }]

      return this.BlobMixin_SaveBlobs(blobs)
    },
    async BlobMixin_GetFiles (idKoppeling, type, subtype = null) {
      var responseFiles = await this.BlobMixin_GetBlobs({
        idKoppeling: idKoppeling,
        type: type,
        subtype: subtype
      })

      var files = []

      if (responseFiles != null) {
        responseFiles.forEach(file => {
          files.push({
            idBlob: file.idBlob,
            status: file.blobStatus,
            name: file.bestandsnaam,
            size: file.size
          })
        })
      }
      return files
    },
    async BlobMixin_GetBlobs (blobs) {
      if (blobs) {
        const resp = await blobService.GetBySearchCriteria(blobs)

        if (resp && (resp.data || resp.data !== '')) {
          return resp.data
        }
      }
      return null
    },
    async BlobMixin_DownloadAction (fileStream, fileName) {
      const file = window.URL.createObjectURL(fileStream)
      const docUrl = document.createElement('a')
      docUrl.href = file
      docUrl.setAttribute('download', fileName.replaceAll('"', ''))
      docUrl.click()
    },
    async BlobMixin_SaveFiles (files, idKoppeling, type, subtype = null) {
      if (!files || files.length === 0) return []

      // Handle deleted files immediately (synchronous)
      const deletedFiles = files.filter(f => f.status === this.blobMixin.status.deleted)
      for (const file of deletedFiles) {
        if (file.idBlob) {
          await this.BlobMixin_DeleteBlobById(file.idBlob)
        }
      }

      // Handle new files - queue for async upload
      const newFiles = files.filter(f => f.status === this.blobMixin.status.new)

      if (newFiles.length > 0) {
        // Queue files for async upload (non-blocking)
        const uploadIds = await fileUploadService.queueMultipleFiles(newFiles, idKoppeling, type, subtype)

        this.CommonMixin_Snackbar(
          `${newFiles.length} bestand${newFiles.length > 1 ? 'en' : ''} in wachtrij voor upload`,
          'info',
          3
        )

        return uploadIds
      }

      return []
    }
  }
}
